import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rich-text",
  "use": "rich-text-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"rich-text\"><path fill-rule=\"evenodd\" d=\"m18 4.5 1.16 4.35-.96.26c-.45-.87-.91-1.74-1.44-2.18-.53-.43-1.15-.43-1.76-.43h-2V17c0 .5 0 1 .33 1.25.34.25 1 .25 1.67.25v1H9v-1c.67 0 1.33 0 1.67-.25C11 18 11 17.5 11 17V6.5H9c-.61 0-1.23 0-1.76.43-.53.44-.99 1.31-1.44 2.18l-.96-.26L6 4.5h12Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol